const ACTIONS = {
    FETCH_REQUEST: "FETCH_DASHBOARD_REQUEST",
    FETCH_SUCCESS: "FETCH_DASHBOARD_SUCCESS",
    FETCH_FAIL: "FETCH_DASHBOARD_FAIL",

    REFRESH_COUNTER_REQUEST: "REFRESH_COUNTER_REQUEST",
    REFRESH_COUNTER_SUCCESS: "REFRESH_COUNTER_SUCCESS",
    REFRESH_COUNTER_FAIL: "REFRESH_COUNTER_FAIL",
};

export default ACTIONS;
